import { UploadedFile } from '../../hooks/file-uploads/types';

// When the dragged file is part of a multi-selection, the whole selection moves together;
// otherwise only the dragged file moves.
export function resolveFilesToMove(
  draggedItem: UploadedFile,
  allFiles: UploadedFile[],
  selectedIds?: ReadonlySet<string>,
): UploadedFile[] {
  if (selectedIds && selectedIds.has(draggedItem.id)) {
    return allFiles.filter(file => selectedIds.has(file.id));
  }
  return [draggedItem];
}
